export const BASE_URI = import.meta.env.VITE_API_URI;

export const BASE_API = "api";

export const BASE_INFO = "info";

export const BASE_ADMIN = "admin";

export const API_LOGIN = "login";

export const API_LOGIN_2FA = "login-2fa";

export const API_REGISTER = "register";

export const API_ACCOUNT = "account";

export const API_FORGOT = "reset-password";

export const API_UPLOAD_IMG = "uploadImage";

export const API_DELETE_IMG = "deleteImage";

export const API_ACTIVATION = "activation";

export const API_CONNECTED_OBJECT = "connected-object";

export const API_SEARCH = "search";

export const API_FEATURE_ADD = "add-feature";

export const API_FEATURE_EDIT = "edit-feature";

export const API_FEATURE_LIST = "features";

export const API_FILTE = "file";

export const API_URL = "url";

export const API_USER = "user";

export const API_USERS = "users";

export const API_ACTIVATION_USER = "activation-user";

export const API_RESET_USER_PASSWORD = "reset-password";

export const API_PROFILE = "profil";

export const API_GOOGLE_PLACE = "google-place";

export const API_INACTIVE = "inactive";

export const API_ACTIVE = "active";

export const API_ALL = "ALL";

export const API_GENERATE = "generate";

export const API_TRACKING = "tracking";

export const API_EXCHANGE_CONTACT = "exchange-contact";

export const API_EQUIPMENT = "equipment";

export const API_EQUIPMENT_BY_OBJECT = "by-object";

export const API_SITES = "sites";

export const API_IMPORT_CSV = "import-csv";

export const API_EQUIPMENT_BATCH_ASSIGN_SITE = "batch-assign-site";
